import { render } from "./의무기록사본발급.vue?vue&type=template&id=1cc8d6d4"
import script from "./의무기록사본발급.vue?vue&type=script&lang=js"
export * from "./의무기록사본발급.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__